import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { StatusHistoryChainComponent } from './status-history-chain.component';
import { TimezoneModule } from '../timezone/timezone.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { DateWithProfileAndLocalTimezoneModule } from '../profile-and-local-date/date-with-profile-and-local-timezone.module';

@NgModule({
  declarations: [StatusHistoryChainComponent],
  imports: [
    CommonModule,
    IntrackFeatureModule,
    TranslateModule,
    TimezoneModule,
    SvgIconModule,
    DateWithProfileAndLocalTimezoneModule,
  ],
  exports: [StatusHistoryChainComponent],
})
export class StatusHistoryChainModule {}
